import { friendsQueryOptions } from '@/hooks/contacts/use-friends';
import { groupsQueryOptions } from '@/hooks/contacts/use-groups';
import { tagListQueryOptions } from '@/hooks/tags/use-tags';
import { blacklistQueryOptions } from '@/hooks/users/use-blacklist';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export const createBatchMessageLoader = () => ({
  promises: Promise.allSettled([
    queryClient.ensureQueryData(blacklistQueryOptions).catch(catchFetcherError),
    queryClient.ensureQueryData(friendsQueryOptions).catch(catchFetcherError),
    queryClient.ensureQueryData(groupsQueryOptions).catch(catchFetcherError),
    queryClient.ensureQueryData(tagListQueryOptions).catch(catchFetcherError),
  ]),
});
